import api from "./axios";
import { apiPaths } from "./endpoints";
import type { Image, ImageStats } from "@/types";

export const upload = (file: File) => {
  const formData = new FormData();
  formData.append("file", file);
  return api
    .post<{ image: Image; encryptedUnlockKey: string }>(
      apiPaths.images.upload,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    )
    .then((r) => r.data);
};

export const download = (imageId: string, encryptedUnlockKey: string) =>
  api
    .post(
      apiPaths.images.download(imageId),
      { encryptedUnlockKey },
      { responseType: "blob" },
    )
    .then((r) => r.data as Blob);

export const list = (params?: { search?: string; sort?: string }) =>
  api.get<Image[]>(apiPaths.images.root, { params }).then((r) => r.data);

export const getById = (id: string) =>
  api.get<Image>(apiPaths.images.byId(id)).then((r) => r.data);

export const getStats = () =>
  api.get<ImageStats>(apiPaths.images.stats).then((r) => r.data);

export const getTrash = () =>
  api.get<Image[]>(apiPaths.images.trash).then((r) => r.data);

export const softDelete = (id: string) =>
  api.delete(apiPaths.images.byId(id)).then((r) => r.data);

export const restore = (id: string) =>
  api.post(apiPaths.images.restore(id)).then((r) => r.data);

export const permanentDelete = (id: string) =>
  api.delete(apiPaths.images.permanent(id)).then((r) => r.data);
